import { font, query, space } from '@design/templateFns';
import { ThemeSpacingName } from '@design/theme';
import { ThemeFontName } from '@design/types';
import styled from 'styled-components';

// ${props => props.size ? `${font(props.size)};` : `${font('headline-sm')};`}
export const Header = styled.h2<{
  $font?: ThemeFontName;
  $m?: string;
  $p?: string;
  $color?: string;
  $mobileFont?: ThemeFontName;
}>`
  ${({ $font }) => ($font ? font($font) : font('headline-sm'))};
  ${({ $m }) => ($m ? `margin: ${$m};` : `margin: 0 0 20px;`)}
  ${({ $p }) => ($p ? `padding: ${$p};` : `padding: 0;`)}
  ${({ $color }) => ($color ? `color: ${$color};` : ``)}
  word-break: break-all;

  @media screen and (${query.below('desktop')}) {
    ${({ $mobileFont }) => ($mobileFont ? font($mobileFont) : ``)};
  }
`;

export const Text = styled.p<{
  $font?: ThemeFontName;
  $m?: string;
  $color?: string;
  $mobileFont?: ThemeFontName;
}>`
  ${({ $font }) => ($font ? font($font) : font('body-md'))};
  ${({ $m }) => ($m ? `margin: ${$m};` : ``)}
  ${({ $color }) => ($color ? `color: ${$color};` : ``)}
  @media screen and (${query.below('tablet')}) {
    ${({ $mobileFont }) => ($mobileFont ? font($mobileFont) : ``)};
  }
`;

export const CustomDisclaimer = styled.div<{
  $font?: ThemeFontName;
  $m?: string;
  $color?: string;
  $mobileFont?: ThemeFontName;
}>`
  > * {
    ${({ $font }) => ($font ? font($font) : font('body-xs-light'))};
    ${({ $m }) => ($m ? `margin: ${$m};` : ``)}
    ${({ $color }) => ($color ? `color: ${$color} !important;` : ``)}
  @media screen and (${query.below('tablet')}) {
      ${({ $mobileFont }) => ($mobileFont ? font($mobileFont) : ``)};
    }
  }
  > * p {
    ${({ $font }) => ($font ? font($font) : font('body-md'))};
    ${({ $m }) => ($m ? `margin: ${$m};` : ``)}
    @media screen and (${query.below('tablet')}) {
      ${({ $mobileFont }) => ($mobileFont ? font($mobileFont) : ``)};
    }
  }
`;

export const List = styled.div<{
  $gap?: ThemeSpacingName;
  $p?: ThemeSpacingName;
  $bg?: string;
  $center?: boolean;
  $centerHorz?: boolean;
  $centerVert?: boolean;
}>`
  display: grid;
  grid-gap: ${({ $gap }) => ($gap ? space($gap) : '0px')};
  padding: ${({ $p }) => ($p ? space($p) : '0px')};
  background-color: ${({ $bg }) => ($bg ? $bg : 'transparent')};
  ${({ $center }) =>
    $center
      ? `
    justify-items: center;
    align-content: center;
  `
      : ``}
  ${({ $centerHorz }) =>
    $centerHorz
      ? `
    justify-content: center;
  `
      : ``}
  ${({ $centerVert }) =>
    $centerVert
      ? `
    align-content: center;
  `
      : ``}
  @media screen and (${query.below('tablet')}) {
    width: 100%;
    box-sizing: border-box;
  }
`;

export const ListCol = styled.div<{
  $gap?: ThemeSpacingName;
  $p?: ThemeSpacingName;
  $bg?: string;
  $center?: boolean;
  $centerHorz?: boolean;
  $centerVert?: boolean;
}>`
  display: grid;
  grid-auto-flow: column;
  grid-gap: ${({ $gap }) => ($gap ? space($gap) : '0px')};
  padding: ${({ $p }) => ($p ? space($p) : '0px')};
  background-color: ${({ $bg }) => ($bg ? $bg : 'transparent')};
  justify-content: start;
  ${({ $center }) =>
    $center
      ? `
    justify-items: center;
    align-content: center;
  `
      : ``}
  ${({ $centerHorz }) =>
    $centerHorz
      ? `
    justify-content: center;
  `
      : ``}
  ${({ $centerVert }) =>
    $centerVert
      ? `
    align-items: center;
  `
      : ``}
  @media screen and (${query.below('desktop')}) {
    grid-template-columns: 1fr auto 1fr;
  }
`;

export const ListColAlt = styled.div<{
  $gap?: ThemeSpacingName;
  $p?: ThemeSpacingName;
}>`
  display: grid;
  grid-auto-flow: column;
  justify-content: space-between;
  align-items: start;
  grid-gap: ${({ $gap }) => ($gap ? space($gap) : '0px')};
  padding: ${({ $p }) => ($p ? space($p) : '0px')};
  @media screen and (${query.below('desktop')}) {
    grid-auto-flow: row;
    grid-template-columns: 1fr;
  }
`;

export const StyledLogoWrapper = styled.div`
  width: 49px;
  height: 19px;
  display: flex;
  position: relative;
`;

export const PaymentCalculatorStyles = styled.div`
  text-align: center;
  @media screen and (${query.atLeast('tablet')}) {
    min-width: 288px;
  }
`;
